import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import '@isceco/widget-library2/basic-elements/Form/Form.js'
import '@isceco/widget-library2/basic-elements/FileInput/FileInput.js'
import BerechtigteFileInputService from '../../services/BerechtigteFileInputService'
import FileUploadService from '../../services/FileUploadService'
import GPImportService from './GPImportService'
import StaticRow from '@isceco/widget-library2/basic-elements/List/StaticRow.js'
import ImportResultRowVariant from './ImportResultRowVariant'
import ImportResultColumns from './ImportResultColumns'

export default class GPImport extends WebComponent {

  constructor() {
    super()
    this.fileUploadService = new FileUploadService()
    this.gpImportService = new GPImportService()
  }

  get translationFile() {
    return './views/GPImport/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()

    this.reload()
  }

  reload() {
    Promise.resolve(this.fileUploadService.getBackendListUrl())
      .then(fileUploadUrl => {
        this.fileUploadUrl = fileUploadUrl
      })
      .catch(() => {
        this.fileUploadUrl = ''
      })
      .finally(() => {
        this.render()
      })
  }

  getTemplate() {
    const maxsize = 50000000 // 50 MB
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('gp.import.title')}">
      </isceco-title>
      <p>${this.i18n.translate('gp.import.beschreibung')}</p>
      <div style="max-width: fit-content">
        <isceco-button text="${this.i18n.translate('gp.vorlage.herunterladen')}"
                       variant="tertiary" size="small"
                       icon="file alternate"
                       @click="${this._downloadTemplate}"
        ></isceco-button>
      </div>
      <br/>
      <isceco-form id="import-form"
                   .prevent-navigation="true"
                   submit-button-text="${this.i18n.translate('gp.import.form.submit')}"
                   @submit="${e => this._submitImport(e)}">
        <div slot="form-elements">
          <isceco-file-input name="file" required
                             label="${this.i18n.translate('gp.import.form.datei.label')}"
                             url="${this.fileUploadUrl}"
                             maxsize="${maxsize}"
                             accept="text/csv"
                             .fileInputService="${BerechtigteFileInputService}"
          ></isceco-file-input>
        </div>
      </isceco-form>
      <br/>
      <isceco-title text="${this.i18n.translate('gp.import.result.title')}"
                    help-text="${this.i18n.translate('gp.import.result.title.help')}"
                    size="small"
      ></isceco-title>
      <isceco-static-list id="results-list"
                          .i18n="${this.i18n}"
                          .columns="${ImportResultColumns.getColumns()}"
                          .data="${this.importResults ?? []}"
                          .rowVariant="${new ImportResultRowVariant()}"
      </isceco-static-list>
    `
  }

  _submitImport = event => {
    event.target.setAttribute('disabled', true)
    document.querySelector('#import-form isceco-file-input').setAttribute('disabled', 'true')
    this.render()
    const form = event.detail
    this.gpImportService.create(form)
      .then(json => {
        this.importResults = json.map(r => new StaticRow(r))
      })
      .finally(() => {
        this.render()
      })
  }

  _downloadTemplate = () => {
    this.gpImportService.downloadTemplate()
      .then(response => {
        response.blob().then(blob => {
          download(response.headers.get('Content-Disposition').split('"')[1], blob)
        })
      })
  }

}

customElements.define('eko-frontend-gpimport', GPImport)
